import { useState, useRef, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Autocomplete,
  InputLabel,
  InputAdornment,
  Paper,
  useTheme,
  Typography,
  Box,
  IconButton,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
} from "@mui/material";
import { CloudUpload, Delete } from "@mui/icons-material";
import { Slide } from "@mui/material";
import { IMAGE } from "../../../api";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { DatePicker, TimeField } from "@mui/x-date-pickers";

const DynamicFormModal = ({
  open,
  onClose,
  formStructure,
  onSubmit,
  formData,
  setFormData,
  initialData,
  title,
  // darkMode = false,
}) => {
  const theme = useTheme();
  const darkMode = JSON.parse(sessionStorage.getItem("darkMode"));
  // const [formData, setFormData] = useState({});
  const [filePreviews, setFilePreviews] = useState({});
  const [allowSubmit, setAllowSubmit] = useState(true);
  const fileInputRefs = useRef({});
  if (!formData) {
    console.warn("formData is undefined!");
    return null; // or a loading spinner, or skip rendering the form
  }
  // console.log(onClose, "fdsfdffdsfsdfsdf");
  const handleClose = () => {
    onClose(); // Call parent's onClose
    setTimeout(() => {
      setAllowSubmit(true); // Reset submit state
      setFilePreviews({});
    }, 100);
  };
  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useMemo(()=>{

  // },[])
  // useMemo(()=>{
  //   if(initialData != {} ){
  //     setFormData(initialData)
  //   }
  // },[initialData])

  const handleFileChange = (fieldName, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Store the file object
    handleChange(fieldName, file);

    // Create preview for images
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFilePreviews((prev) => ({
          ...prev,
          [fieldName]: e.target.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFilePreviews((prev) => ({
        ...prev,
        [fieldName]: file.name,
      }));
    }
  };

  const removeFile = (fieldName) => {
    handleChange(fieldName, null);
    setFilePreviews((prev) => {
      const newPreviews = { ...prev };
      delete newPreviews[fieldName];
      return newPreviews;
    });
    if (fileInputRefs.current[fieldName]) {
      fileInputRefs.current[fieldName].value = "";
    }
  };

  // const handleSubmit = () => {

  //   onSubmit(formData);
  //   onClose();
  //   setFormData({});
  //   setFilePreviews({});
  // };

  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevent default submission

    let requiredFieldCount = 0; // Total required fields count
    let requiredFieldFilledCount = 0; // Filled required fields count
    let emailValid = true; // Email validity flag
    let mobileValid = true; // Mobile number validity flag
    let pancardValid = true; // PAN validity flag
    let gstValid = true; // GST validity flag

    formStructure?.forEach((field) => {
      console.log(field.required, formStructure, "Hiii Parth Check THis");
      if (field.required && field.display !== "none") {
        requiredFieldCount++; // Count all required fields
        const fieldValue = String(formData[field.name] || "").trim(); // Ensure the field value is a string
        // console.log(fieldValue, "dsfdfsdd");
        // General required field check
        if (fieldValue) {
          // Email validation
          if (field?.isEmail) {
            const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
            if (!emailRegex.test(fieldValue)) {
              emailValid = false; // Email is invalid
            } else {
              requiredFieldFilledCount++; // Increment count for valid email
            }
          }

          // Mobile validation
          if (field?.isMobile) {
            const digits = fieldValue.replace(/\D/g, "").slice(2); // Extract digits after +91
            if (digits.length === 10) {
              requiredFieldFilledCount++; // Increment count for valid mobile number
            } else {
              mobileValid = false; // Mobile number is invalid
            }
          }

          // PAN validation
          if (field?.isPancard) {
            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
            if (!panRegex.test(fieldValue)) {
              pancardValid = false; // PAN is invalid
            } else {
              requiredFieldFilledCount++; // Increment count for valid PAN
            }
          }

          // GST validation
          if (field?.isGst) {
            const gstRegex =
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
            if (!gstRegex.test(fieldValue)) {
              gstValid = false; // PAN is invalid
            } else {
              requiredFieldFilledCount++; // Increment count for valid PAN
            }
          }

          // For other fields
          if (
            !field.isEmail &&
            !field.isMobile &&
            !field?.isGst &&
            !field?.isPancard
          ) {
            requiredFieldFilledCount++; // Increment count if field is filled
          }
        }
      }
    });

    // Validate the form
    const isFormValid =
      requiredFieldCount === requiredFieldFilledCount &&
      emailValid &&
      mobileValid &&
      pancardValid &&
      gstValid;
    // console.log(isFormValid, "grretertert");
    console.log(
      "chchhchchchcch",
      isFormValid,
      requiredFieldCount,
      requiredFieldFilledCount,
    );

    if (isFormValid) {
      // console.log("chchhchchchcch12");
      setAllowSubmit(true); // Allow submission
      onSubmit(formData); // Call submit handler
      setTimeout(() => {
        // setAllowSubmit(true) ; // Reset submit state
        setFilePreviews({});
      }, 100);
    } else {
      setAllowSubmit(false); // Block submission
      console.error({
        requiredFieldCount,
        requiredFieldFilledCount,
        emailValid,
        mobileValid,
        pancardValid,
        formData,
      }); // Log detailed debug info
    }
  };

  // Theme-based styles
  // const dialogStyles = {
  //   "& .MuiDialog-container": {
  //     alignItems: "flex-start",
  //   },
  //   "& .MuiPaper-root": {
  //     marginTop: "5vh",
  //     width: "25%",
  //     maxWidth: "800px",
  //     maxHeight: "80vh",
  //     overflow: "auto",
  //     backgroundColor: darkMode
  //       ? theme.palette.grey[900]
  //       : theme.palette.background.paper,
  //     color: darkMode ? theme.palette.text.primary : theme.palette.text.primary,
  //     border: darkMode
  //       ? "1px solid rgba(255, 255, 255, 0.12)"
  //       : "1px solid rgba(0, 0, 0, 0.12)",
  //   },
  // };

  // const textFieldStyles = {
  //   borderRadius: 2,
  //   backgroundColor: "var(--themeColorLighterShade)",
  //   "& .MuiOutlinedInput-notchedOutline": {
  //     borderColor: "var(--themeColorLighterShade)  !important",
  //   },
  //   "& input:-webkit-autofill": {
  //     WebkitBoxShadow: darkMode
  //       ? "0 0 0 100px rgb(22, 22, 22) inset"
  //       : "0 0 0 100px rgb(255, 255, 255) inset", // Red background for autofill
  //     WebkitTextFillColor: "var(--themeFontColor)", // Text color for autofilled content
  //   },
  // };

  // const inputLabelStyles = {
  //   color: darkMode ? theme.palette.text.secondary : theme.palette.text.primary,
  // };

  // const fileUploadStyles = {
  //   border: `2px dashed ${
  //     darkMode ? theme.palette.grey[700] : theme.palette.grey[400]
  //   }`,
  //   borderRadius: 2,
  //   padding: 3,
  //   textAlign: "center",
  //   display: "flex",
  //   gap: "1rem",
  //   alignItems: "center",
  //   cursor: "pointer",
  //   // backgroundColor: darkMode ? theme.palette.grey[800] : theme.palette.grey[100],
  //   // '&:hover': {
  //   //   borderColor: theme.palette.primary.main,
  //   //   backgroundColor: darkMode ? theme.palette.grey[700] : theme.palette.grey[200]
  //   // }
  // };

  const dialogStyles = {
    "& .MuiDialog-container": {
      alignItems: "flex-start",
    },
    "& .MuiPaper-root": {
      marginTop: "5vh",
      width: "25%",
      maxWidth: "800px",
      maxHeight: "80vh",
      overflow: "auto",
      borderRadius: "16px",
      backdropFilter: "blur(16px)",
      boxShadow: darkMode
        ? "0 25px 50px -12px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.05)"
        : "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)",
      backgroundColor: darkMode
        ? "rgba(17, 24, 39, 0.95)"
        : "rgba(255, 255, 255, 0.95)",
      border: darkMode
        ? "1px solid rgba(75, 85, 99, 0.3)"
        : "1px solid rgba(229, 231, 235, 0.3)",
    },
  };

  const textFieldStyles = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: darkMode
        ? "rgba(31, 41, 55, 0.8)"
        : "rgba(248, 250, 252, 0.8)",
      backdropFilter: "blur(8px)",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: darkMode
          ? "rgba(31, 41, 55, 0.9)"
          : "rgba(248, 250, 252, 0.9)",
        transform: "translateY(-1px)",
        boxShadow: darkMode
          ? "0 4px 12px rgba(0, 0, 0, 0.3)"
          : "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
      "&.Mui-focused": {
        backgroundColor: darkMode
          ? "rgba(31, 41, 55, 1)"
          : "rgba(255, 255, 255, 1)",
        boxShadow: darkMode
          ? "0 0 0 2px rgba(59, 130, 246, 0.5)"
          : "0 0 0 2px rgba(99, 102, 241, 0.5)",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: darkMode
          ? "rgba(75, 85, 99, 0.3)"
          : "rgba(209, 213, 219, 0.3)",
        borderWidth: "1px",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: darkMode
          ? "rgba(156, 163, 175, 0.5)"
          : "rgba(156, 163, 175, 0.5)",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: darkMode
          ? "rgba(59, 130, 246, 0.8)"
          : "rgba(99, 102, 241, 0.8)",
        borderWidth: "2px",
      },
    },
    "& input": {
      color: darkMode ? "rgba(243, 244, 246, 1)" : "rgba(17, 24, 39, 1)",
      "&::placeholder": {
        color: darkMode
          ? "rgba(156, 163, 175, 0.8)"
          : "rgba(107, 114, 128, 0.8)",
      },
    },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: darkMode
        ? "0 0 0 100px rgba(31, 41, 55, 1) inset"
        : "0 0 0 100px rgba(255, 255, 255, 1) inset",
      WebkitTextFillColor: darkMode
        ? "rgba(243, 244, 246, 1)"
        : "rgba(17, 24, 39, 1)",
    },
  };

  const inputLabelStyles = {
    color: darkMode ? "rgba(209, 213, 219, 0.9)" : "rgba(55, 65, 81, 0.9)",
    fontWeight: "600",
    fontSize: "0.875rem",
    marginBottom: "8px",
  };

  const fileUploadStyles = {
    border: `2px dashed ${
      darkMode ? "rgba(75, 85, 99, 0.5)" : "rgba(156, 163, 175, 0.5)"
    }`,
    borderRadius: "12px",
    padding: 3,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: darkMode
      ? "rgba(31, 41, 55, 0.3)"
      : "rgba(248, 250, 252, 0.3)",
    backdropFilter: "blur(8px)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: darkMode
        ? "rgba(59, 130, 246, 0.5)"
        : "rgba(99, 102, 241, 0.5)",
      backgroundColor: darkMode
        ? "rgba(31, 41, 55, 0.5)"
        : "rgba(248, 250, 252, 0.5)",
      transform: "translateY(-1px)",
    },
  };

  const getInputStyles = (field, darkMode, theme) => {
    const baseInputProps = {
      sx: {
        borderRadius: "12px",
        backgroundColor: darkMode
          ? "rgba(31, 41, 55, 0.8)"
          : "rgba(248, 250, 252, 0.8)",
        backdropFilter: "blur(8px)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: darkMode
            ? "rgba(31, 41, 55, 0.9)"
            : "rgba(248, 250, 252, 0.9)",
          transform: "translateY(-1px)",
          boxShadow: darkMode
            ? "0 4px 12px rgba(0, 0, 0, 0.3)"
            : "0 4px 12px rgba(0, 0, 0, 0.1)",
        },
        "&.Mui-focused": {
          backgroundColor: darkMode
            ? "rgba(31, 41, 55, 1)"
            : "rgba(255, 255, 255, 1)",
          boxShadow: darkMode
            ? "0 0 0 2px rgba(59, 130, 246, 0.5)"
            : "0 0 0 2px rgba(99, 102, 241, 0.5)",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: darkMode
            ? "rgba(75, 85, 99, 0.3) !important"
            : "rgba(209, 213, 219, 0.3) !important",
          borderWidth: "1px",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: darkMode
            ? "rgba(156, 163, 175, 0.5) !important"
            : "rgba(156, 163, 175, 0.5) !important",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: darkMode
            ? "rgba(59, 130, 246, 0.8) !important"
            : "rgba(99, 102, 241, 0.8) !important",
          borderWidth: "2px",
        },
        "& input:-webkit-autofill": {
          WebkitBoxShadow: darkMode
            ? "0 0 0 100px rgba(31, 41, 55, 1) inset"
            : "0 0 0 100px rgba(255, 255, 255, 1) inset",
          WebkitTextFillColor: darkMode
            ? "rgba(243, 244, 246, 1)"
            : "rgba(17, 24, 39, 1)",
        },
        "& input": {
          color: darkMode ? "rgba(243, 244, 246, 1)" : "rgba(17, 24, 39, 1)",
          "&::placeholder": {
            color: darkMode
              ? "rgba(156, 163, 175, 0.8)"
              : "rgba(107, 114, 128, 0.8)",
          },
        },
        "& textarea": {
          color: darkMode ? "rgba(243, 244, 246, 1)" : "rgba(17, 24, 39, 1)",
          "&::placeholder": {
            color: darkMode
              ? "rgba(156, 163, 175, 0.8)"
              : "rgba(107, 114, 128, 0.8)",
          },
        },
      },
    };

    const baseInputPropsLower = {
      min: field?.min,
      max: field?.max,
      step: field?.step || 1,
      maxLength: field?.maxLength,
      style: {
        color: darkMode ? "rgba(243, 244, 246, 1)" : "rgba(17, 24, 39, 1)",
        paddingLeft: "10px",
      },
    };

    const baseLabelProps = {
      sx: {
        color: darkMode ? "rgba(209, 213, 219, 0.9)" : "rgba(55, 65, 81, 0.9)",
        fontWeight: "600",
        fontSize: "0.875rem",
        marginBottom: "8px",
      },
    };

    return {
      InputProps: baseInputProps,
      inputProps: baseInputPropsLower,
      InputLabelProps: baseLabelProps,
    };
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      TransitionComponent={Slide}
      TransitionProps={{ direction: "down" }}
      sx={dialogStyles}
    >
      <DialogTitle
        sx={{
          background: darkMode
            ? "linear-gradient(135deg, rgba(31, 41, 55, 0.95) 0%, rgba(17, 24, 39, 0.95) 50%, rgba(31, 41, 55, 0.95) 100%)"
            : "linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(219, 234, 254, 0.95) 50%, rgba(238, 242, 255, 0.95) 100%)",
          borderBottom: darkMode
            ? "1px solid rgba(75, 85, 99, 0.3)"
            : "1px solid rgba(229, 231, 235, 0.3)",
          color: darkMode ? "rgba(243, 244, 246, 1)" : "rgba(17, 24, 39, 1)",
          fontWeight: "700",
          fontSize: "1.5rem",
          padding: "24px 32px",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: darkMode
            ? "rgba(17, 24, 39, 0.98)"
            : "rgba(255, 255, 255, 0.98)",
          padding: "32px",
        }}
      >
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {formStructure?.map((field, index) => {
            switch (field.type) {
              case "inputBox":
                const inputBoxStyles = getInputStyles(field, darkMode, theme);
                return (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    key={index}
                    display={field.display || "block"}
                  >
                    <InputLabel shrink sx={inputLabelStyles}>
                      {field.title}
                      {field.required && (
                        <span
                          style={{
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      )}
                    </InputLabel>
                    <TextField
                      fullWidth
                      value={formData[field?.name] || ""}
                      size="small"
                      onChange={(e) => {
                        if (field.regex) {
                          if (
                            e.target.value === "" ||
                            field.regex.test(e.target.value)
                          ) {
                            handleChange(field.name, e.target.value);
                          }
                        } else {
                          handleChange(field.name, e.target.value);
                        }
                      }}
                      placeholder={field.placeholder}
                      required={field.required}
                      multiline={field.multiline}
                      rows={field.row}
                      disabled={field.disabled}
                      // inputProps={{
                      //   maxLength: field.maxLength || undefined,
                      // }}
                      // sx={textFieldStyles}
                      error={
                        (field.required && !formData[field.name]) ||
                        (field.regex &&
                          formData[field.name] &&
                          !field.regex.test(formData[field.name]))
                      }
                      helperText={
                        (!allowSubmit &&
                          field.required &&
                          !formData[field.name] && (
                            <span
                              style={{
                                color: darkMode
                                  ? "rgba(248, 113, 113, 1)"
                                  : "rgba(220, 38, 38, 1)",
                              }}
                            >
                              Please fill this field
                            </span>
                          )) ||
                        (field.regex &&
                          formData[field.name] &&
                          !field.regex.test(formData[field.name]) && (
                            <span
                              style={{
                                color: darkMode
                                  ? "rgba(248, 113, 113, 1)"
                                  : "rgba(220, 38, 38, 1)",
                              }}
                            >
                              {field.errorMessage || "Invalid input format"}
                            </span>
                          )) ||
                        (field.maxLength && (
                          <span
                            style={{
                              color:
                                formData[field.name]?.length >= field.maxLength
                                  ? darkMode
                                    ? "rgba(248, 113, 113, 1)"
                                    : "rgba(220, 38, 38, 1)"
                                  : darkMode
                                    ? "rgba(156, 163, 175, 1)"
                                    : "rgba(107, 114, 128, 1)",
                              float: "right",
                              fontSize: "0.75rem",
                            }}
                          >
                            {formData[field.name]?.length || 0}/
                            {field.maxLength}
                          </span>
                        ))
                      }
                      InputProps={inputBoxStyles.InputProps}
                      inputProps={inputBoxStyles.inputProps}
                      InputLabelProps={inputBoxStyles.InputLabelProps}
                      // InputProps={{
                      //   sx: {
                      //     borderRadius: 2,
                      //     backgroundColor: "var(--themeColorLighterShade)",
                      //     "& .MuiOutlinedInput-notchedOutline": {
                      //       borderColor:
                      //         "var(--themeColorLighterShade)  !important",
                      //     },
                      //     "& input:-webkit-autofill": {
                      //       WebkitBoxShadow: darkMode
                      //         ? "0 0 0 100px rgb(22, 22, 22) inset"
                      //         : "0 0 0 100px rgb(255, 255, 255) inset", // Red background for autofill
                      //       WebkitTextFillColor: "var(--themeFontColor)", // Text color for autofilled content
                      //     },
                      //   },
                      //   inputProps: {
                      //     min: field?.min,
                      //     max: field?.max,
                      //     step: field?.step || 1,
                      //     maxLength: field?.maxLength,
                      //     style: {
                      //       color: "var(--themeFontColor)", // Placeholder color to light grey
                      //       // paddingLeft: "10px", // Left padding for the placeholder
                      //     },
                      //   },
                      // }}
                      // InputLabelProps={{
                      //   sx: inputLabelStyles,
                      //   inputProps: {
                      //     min: field?.min,
                      //     max: field?.max,
                      //     step: field?.step || 1,
                      //     maxLength: field?.maxLength,
                      //     style: {
                      //       color: "var(--themeFontColor)", // Placeholder color to light grey
                      //       paddingLeft: "10px", // Left padding for the placeholder
                      //     },
                      //   },
                      // }}
                    />
                  </Grid>
                );
              case "date":
                const dateStyles = getInputStyles(field, darkMode, theme);
                return (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={field?.size || 12}
                    key={index + "-grid"}
                    display={field.display || "block"}
                  >
                    <InputLabel shrink sx={dateStyles.InputLabelProps.sx}>
                      {field.title}
                      {field.required && (
                        <span
                          style={{
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      )}
                    </InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        // label={value.placeholder || value.title}
                        value={
                          formData?.[field.name]
                            ? dayjs(formData?.[field.name])
                            : null
                        }
                        minDate={field.min ? dayjs(field.min) : undefined}
                        maxDate={field.max ? dayjs(field.max) : undefined}
                        defaultValue={
                          formData?.[field.name]
                            ? undefined
                            : field.default
                              ? dayjs(field.default)
                              : undefined
                        }
                        onChange={(newValue) => {
                          setFormData((prev) => ({
                            ...prev,
                            [field.name]: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          }));
                        }}
                        slots={{
                          openPickerIcon: CalendarTodayIcon,
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            required: field?.required,
                            placeholder: field.placeholder,
                            InputProps: {
                              startAdornment: field?.symbol && (
                                <InputAdornment position="start">
                                  {field.symbol}
                                </InputAdornment>
                              ),
                              sx: {
                                ...dateStyles.InputProps.sx,
                                "& .MuiSvgIcon-root": {
                                  color: darkMode
                                    ? "rgba(59, 130, 246, 1)"
                                    : "rgba(99, 102, 241, 1)",
                                },
                                // borderRadius: 2,
                                // backgroundColor:
                                //   "var(--themeColorLighterShade)",
                                // "& .MuiOutlinedInput-notchedOutline": {
                                //   borderColor:
                                //     "var(--themeColorLighterShade) !important",
                                // },
                                // "& input:-webkit-autofill": {
                                //   WebkitBoxShadow: darkMode
                                //     ? "0 0 0 100px rgb(22, 22, 22) inset"
                                //     : "0 0 0 100px rgb(255, 255, 255) inset",
                                //   WebkitTextFillColor: "var(--themeFontColor)",
                                // },
                              },
                            },

                            inputProps: dateStyles.inputProps,
                            InputLabelProps: dateStyles.InputLabelProps,
                          },
                          openPickerIcon: {
                            sx: {
                              color: darkMode
                                ? "rgba(59, 130, 246, 1)"
                                : "rgba(99, 102, 241, 1)",
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                    {!allowSubmit &&
                      field.required &&
                      !formData[field.name] && (
                        <Typography
                          variant="caption"
                          sx={{
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                            display: "block",
                            mb: 1,
                          }}
                        >
                          Please fill this field
                        </Typography>
                      )}
                  </Grid>
                );
              case "select":
                const selectStyles = getInputStyles(field, darkMode, theme);
                return (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    key={index}
                    display={field.display || "block"}
                  >
                    <InputLabel shrink sx={selectStyles.InputLabelProps.sx}>
                      {field.title}
                      {field.required && (
                        <span
                          style={{
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      )}
                    </InputLabel>
                    <Autocomplete
                      options={field.options || []}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, selectedValue) =>
                        option.value === selectedValue?.value
                      } // Compare by value
                      value={
                        field?.options?.find(
                          (opt) => opt?.value === formData?.[field.name],
                        ) || null
                      }
                      disabled={field?.disabled ? true : false}
                      onChange={(e, newValue) =>
                        handleChange(field.name, newValue?.value || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={field.placeholder}
                          required={field.required}
                          size="small"
                          sx={textFieldStyles}
                          helperText={
                            !allowSubmit &&
                            (formData?.[field.name] == undefined ||
                              formData?.[field.name]?.length <= 0) &&
                            field?.required && (
                              <p
                                style={{
                                  // textAlign: "right",
                                  marginTop: "-3px",
                                  color: darkMode
                                    ? "rgba(248, 113, 113, 1)"
                                    : "rgba(220, 38, 38, 1)",
                                }}
                              >
                                Please fill this field
                              </p>
                            )
                          }
                          // InputLabelProps={{
                          //   sx: inputLabelStyles,
                          // }}
                          // InputProps={{
                          //   ...params.InputProps,
                          //   sx: {
                          //     borderRadius: 2,
                          //     backgroundColor: "var(--themeColorLighterShade)",
                          //     "& .MuiOutlinedInput-notchedOutline": {
                          //       borderColor:
                          //         "var(--themeColorLighterShade)  !important",
                          //     },
                          //   },
                          // }}
                          // inputProps={{
                          //   ...params.inputProps,
                          //   style: {
                          //     paddingLeft: "10px", // Placeholder padding
                          //     color: darkMode ? "#ffffff" : "#151515",
                          //     // color: form?.[value.name]
                          //     //   ? "#151515"
                          //     //   : "rgba(21, 21, 21, 1)", // Light grey placeholder color
                          //   },
                          // }}
                          InputProps={{
                            ...params.InputProps,
                            sx: selectStyles.InputProps.sx,
                          }}
                          inputProps={{
                            ...params.inputProps,
                            ...selectStyles.inputProps,
                          }}
                          InputLabelProps={selectStyles.InputLabelProps}
                          // style={{
                          //   "& .MuiInputBase-root": {
                          //     color: darkMode ? "#ffffff" : "#151515",
                          //   },
                          // }}
                        />
                      )}
                      // PaperComponent={({ children }) => (
                      //   <div
                      //     style={{
                      //       backgroundColor: darkMode
                      //         ? "rgba(100, 206, 70, 0.2)"
                      //         : "rgba(100, 206, 70, 0.1)",
                      //       color: darkMode ? "#ffffff" : "#151515",
                      //       "&:hover": {
                      //         backgroundColor: darkMode ? "#333333" : "#f0f0f7",
                      //       },
                      //     }}
                      //   >
                      //     <Paper
                      //       sx={{
                      //         backgroundColor: darkMode
                      //           ? "rgba(31, 41, 55, 0.95)"
                      //           : "rgba(255, 255, 255, 0.95)",
                      //         backdropFilter: "blur(16px)",
                      //         border: darkMode
                      //           ? "1px solid rgba(75, 85, 99, 0.3)"
                      //           : "1px solid rgba(229, 231, 235, 0.3)",
                      //         borderRadius: "12px",
                      //         boxShadow: darkMode
                      //           ? "0 10px 25px rgba(0, 0, 0, 0.3)"
                      //           : "0 10px 25px rgba(0, 0, 0, 0.1)",
                      //         "& .MuiAutocomplete-option": {
                      //           color: darkMode
                      //             ? "rgba(243, 244, 246, 1)"
                      //             : "rgba(17, 24, 39, 1)",
                      //           "&:hover": {
                      //             backgroundColor: darkMode
                      //               ? "rgba(59, 130, 246, 0.1)"
                      //               : "rgba(99, 102, 241, 0.1)",
                      //           },
                      //           '&[aria-selected="true"]': {
                      //             backgroundColor: darkMode
                      //               ? "rgba(59, 130, 246, 0.2)"
                      //               : "rgba(99, 102, 241, 0.2)",
                      //           },
                      //         },
                      //       }}
                      //     >
                      //       {children}
                      //     </Paper>
                      //   </div>
                      // )}
                      PaperComponent={({ children }) => (
                        <div
                          style={{
                            backgroundColor: darkMode
                              ? "rgba(31, 41, 55, 0.95)"
                              : "rgba(255, 255, 255, 0.95)",
                            color: darkMode ? "#ffffff" : "#151515",
                            "&:hover": {
                              backgroundColor: darkMode
                                ? "rgba(31, 41, 55, 0.95)"
                                : "rgba(255, 255, 255, 0.95)",
                            },
                          }}
                        >
                          <Paper
                            sx={{
                              backgroundColor: darkMode
                                ? "rgba(31, 41, 55, 0.95)"
                                : "rgba(255, 255, 255, 0.95)",
                              backdropFilter: "blur(16px)",
                              border: darkMode
                                ? "1px solid rgba(75, 85, 99, 0.3)"
                                : "1px solid rgba(229, 231, 235, 0.3)",
                              borderRadius: "12px",
                              boxShadow: darkMode
                                ? "0 10px 25px rgba(0, 0, 0, 0.3)"
                                : "0 10px 25px rgba(0, 0, 0, 0.1)",
                              "& .MuiAutocomplete-option": {
                                color: darkMode
                                  ? "rgba(243, 244, 246, 1)"
                                  : "rgba(17, 24, 39, 1)",
                                "&:hover": {
                                  backgroundColor: darkMode
                                    ? "rgba(59, 130, 246, 0.1)"
                                    : "rgba(99, 102, 241, 0.1)",
                                },
                                '&[aria-selected="true"]': {
                                  backgroundColor: darkMode
                                    ? "rgba(59, 130, 246, 0.2)"
                                    : "rgba(99, 102, 241, 0.2)",
                                },
                              },
                            }}
                          >
                            {children}
                          </Paper>
                        </div>
                      )}
                    />
                  </Grid>
                );
              case "file":
                return (
                  <Grid item xs={12} md={12} key={index}>
                    <InputLabel
                      shrink
                      sx={{
                        color: darkMode
                          ? "rgba(209, 213, 219, 0.9)"
                          : "rgba(55, 65, 81, 0.9)",
                        fontWeight: "600",
                        fontSize: "0.875rem",
                        marginBottom: "8px",
                      }}
                    >
                      {field.title}
                      {field.required && (
                        <span
                          style={{
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                            marginLeft: "4px",
                          }}
                        >
                          *
                        </span>
                      )}
                    </InputLabel>

                    <input
                      type="file"
                      id={`file-upload-${field.name}`}
                      ref={(el) => (fileInputRefs.current[field.name] = el)}
                      onChange={(e) => handleFileChange(field.name, e)}
                      accept={field.accept || "*"}
                      style={{ display: "none" }}
                    />

                    {!filePreviews[field.name] && !formData[field.name] ? (
                      <Box
                        component="label"
                        htmlFor={`file-upload-${field.name}`}
                        sx={{
                          border: `2px dashed ${
                            darkMode
                              ? "rgba(75, 85, 99, 0.5)"
                              : "rgba(156, 163, 175, 0.5)"
                          }`,
                          borderRadius: "12px",
                          padding: 3,
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          alignItems: "center",
                          cursor: "pointer",
                          backgroundColor: darkMode
                            ? "rgba(31, 41, 55, 0.3)"
                            : "rgba(248, 250, 252, 0.3)",
                          backdropFilter: "blur(8px)",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            borderColor: darkMode
                              ? "rgba(59, 130, 246, 0.5)"
                              : "rgba(99, 102, 241, 0.5)",
                            backgroundColor: darkMode
                              ? "rgba(31, 41, 55, 0.5)"
                              : "rgba(248, 250, 252, 0.5)",
                            transform: "translateY(-1px)",
                          },
                        }}
                        // sx={fileUploadStyles}
                      >
                        <CloudUpload
                          fontSize="large"
                          sx={{
                            color: darkMode
                              ? "rgba(156, 163, 175, 1)"
                              : "rgba(107, 114, 128, 1)",
                            mb: 1,
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            color: darkMode
                              ? "rgba(243, 244, 246, 1)"
                              : "rgba(17, 24, 39, 1)",
                            fontWeight: "500",
                          }}
                        >
                          Click to upload or drag and drop
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: darkMode
                              ? "rgba(156, 163, 175, 1)"
                              : "rgba(107, 114, 128, 1)",
                          }}
                        >
                          {field.description ||
                            "Supported formats: " + (field.accept || "Any")}
                          {field.maxSize && ` | Max size: ${field.maxSize}MB`}
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          border: `1px solid ${
                            darkMode
                              ? "rgba(75, 85, 99, 0.3)"
                              : "rgba(209, 213, 219, 0.3)"
                          }`,
                          borderRadius: "12px",
                          backgroundColor: darkMode
                            ? "rgba(31, 41, 55, 0.5)"
                            : "rgba(248, 250, 252, 0.5)",
                          backdropFilter: "blur(8px)",
                          p: 2,
                          position: "relative",
                        }}
                      >
                        {/* Handle both local previews and API URLs */}
                        {typeof filePreviews[field.name] === "string" ? (
                          filePreviews[field.name].startsWith("data:image") ? (
                            <img
                              src={filePreviews[field.name]}
                              alt="Preview"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "150px",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          ) : (
                            <Typography
                              sx={{
                                color: darkMode
                                  ? theme.palette.text.primary
                                  : theme.palette.text.primary,
                              }}
                            >
                              {filePreviews[field.name]}
                            </Typography>
                          )
                        ) : typeof formData[field.name] === "string" ? (
                          <img
                            src={`${IMAGE}${formData[field.name]}`}
                            alt="Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "150px",
                              display: "block",
                              margin: "0 auto",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "path_to_fallback_image.jpg";
                            }}
                          />
                        ) : (
                          <Typography
                            sx={{
                              color: darkMode
                                ? theme.palette.text.primary
                                : theme.palette.text.primary,
                            }}
                          >
                            {formData[field.name]?.name || "File selected"}
                          </Typography>
                        )}

                        <IconButton
                          size="small"
                          onClick={() => removeFile(field.name)}
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            color: darkMode
                              ? theme.palette.error.light
                              : theme.palette.error.main,
                            backgroundColor: darkMode
                              ? theme.palette.grey[800]
                              : theme.palette.grey[200],
                            "&:hover": {
                              backgroundColor: darkMode
                                ? theme.palette.grey[700]
                                : theme.palette.grey[300],
                            },
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>

                        <Button
                          size="small"
                          variant="outlined"
                          component="label"
                          htmlFor={`file-upload-${field.name}`}
                          sx={{
                            mt: 1,
                            color: darkMode
                              ? theme.palette.text.secondary
                              : theme.palette.text.primary,
                            borderColor: darkMode
                              ? theme.palette.grey[600]
                              : theme.palette.grey[400],
                          }}
                        >
                          Change File
                        </Button>
                      </Box>
                    )}

                    {!allowSubmit &&
                      field.required &&
                      !formData[field.name] && (
                        <p
                          style={{
                            // textAlign: "right",
                            // marginTop: "-3px",
                            fontSize: "10px",
                            paddingLeft: "10px",
                            color: darkMode
                              ? "rgba(248, 113, 113, 1)"
                              : "rgba(220, 38, 38, 1)",
                          }}
                        >
                          Please upload a file
                        </p>
                        // <Typography
                        //   variant="caption"
                        //   sx={{
                        //     color: darkMode
                        //       ? "rgba(248, 113, 113, 1) !"
                        //       : "rgba(220, 38, 38, 1)",
                        //     display: "block",
                        //     mb: 1,
                        //   }}
                        // >
                        //   Please upload a file
                        // </Typography>
                      )}
                  </Grid>
                );
              case "toggle":
                return (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    key={index + "-grid"}
                    lg={field?.size || 6}
                    container
                    direction="row"
                    alignItems={"center"}
                    display={field.display || "block"}
                    style={{ marginTop: "1rem" }}
                  >
                    <FormControl>
                      <Box sx={{ marginTop: "20px" }}>
                        <InputLabel
                          shrink
                          sx={{
                            fontWeight: "600",
                            color: darkMode
                              ? "rgba(209, 213, 219, 0.9)"
                              : "rgba(55, 65, 81, 0.9)",
                            marginLeft: "-10px",
                            fontSize: "0.875rem",
                          }}
                        >
                          <span>{field.title}</span>
                          {field?.required && (
                            <span
                              style={{
                                color: darkMode
                                  ? "rgba(248, 113, 113, 1)"
                                  : "rgba(220, 38, 38, 1)",
                                paddingLeft: "5px",
                              }}
                            >
                              *
                            </span>
                          )}
                        </InputLabel>
                      </Box>

                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        {field?.options?.map((option, index) => (
                          <FormControlLabel
                            key={field.name + index}
                            value={option.value}
                            name={field.name}
                            required={field?.required}
                            disabled={field.disabled ? true : false}
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                [event.target.name]: event.target.value,
                              });
                            }}
                            control={
                              <Radio
                                color={option.color}
                                // required

                                checked={
                                  formData?.[field.name] != undefined
                                    ? formData?.[field.name] == option.value
                                    : option.value == field?.default
                                }
                                sx={{
                                  color: darkMode
                                    ? "rgba(156, 163, 175, 1)"
                                    : "rgba(107, 114, 128, 1)",
                                  "&.Mui-checked": {
                                    color: darkMode
                                      ? "rgba(59, 130, 246, 1)"
                                      : "rgba(99, 102, 241, 1)",
                                  },
                                }}
                              />
                            }
                            label={
                              <span
                                style={{
                                  color: darkMode
                                    ? "rgba(243, 244, 246, 1)"
                                    : "rgba(17, 24, 39, 1)",
                                  fontWeight: "500",
                                }}
                              >
                                {option.value}
                              </span>
                            }
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <div>
                      {!allowSubmit &&
                        field.required &&
                        !formData?.[field.name] && (
                          <Typography
                            variant="caption"
                            sx={{
                              marginTop: "-1px",
                              fontSize: "0.75rem",
                              color: darkMode
                                ? "rgba(248, 113, 113, 1)"
                                : "rgba(220, 38, 38, 1)",
                            }}
                          >
                            Please fill this field
                          </Typography>
                        )}
                    </div>
                  </Grid>
                );
              default:
                return null;
            }
          })}
        </Grid>
      </DialogContent>
      {/* <DialogActions
        sx={{
          backgroundColor: "var(--themeColor)",
          borderTop: darkMode
            ? "1px solid rgba(255, 255, 255, 0.12)"
            : "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Button
          onClick={handleClose}
          sx={{
            color: "var(--gradientColor2)",
            border: "1px solid var(--gradientColor2)",
            "&:hover": {
              backgroundColor: "var(--gradientColor2)",
              color: "#fff",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => handleFormSubmit(e)}
          variant="contained"
          sx={{
            background: "var(--gradientColor2)",
            color: "#fff",
            padding: "0.5rem 1rem",
            // fontSize: "10px",
            // fontWeight: "400",
            "&:hover": {
              backgroundColor: "var(--gradientColor2)",
              opacity: "70%",
            },
          }}
        >
          Save
        </Button>
      </DialogActions> */}
      <DialogActions
        sx={{
          background: darkMode
            ? "linear-gradient(135deg, rgba(31, 41, 55, 0.95) 0%, rgba(17, 24, 39, 0.95) 100%)"
            : "linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(255, 255, 255, 0.95) 100%)",
          borderTop: darkMode
            ? "1px solid rgba(75, 85, 99, 0.3)"
            : "1px solid rgba(229, 231, 235, 0.3)",
          padding: "24px 32px",
          gap: "12px",
        }}
      >
        <Button
          onClick={handleClose}
          sx={{
            color: darkMode
              ? "rgba(156, 163, 175, 1)"
              : "rgba(107, 114, 128, 1)",
            border: darkMode
              ? "1px solid rgba(75, 85, 99, 0.5)"
              : "1px solid rgba(209, 213, 219, 0.5)",
            borderRadius: "12px",
            padding: "10px 24px",
            fontWeight: "600",
            textTransform: "none",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: darkMode
                ? "rgba(75, 85, 99, 0.1)"
                : "rgba(243, 244, 246, 0.5)",
              borderColor: darkMode
                ? "rgba(156, 163, 175, 0.5)"
                : "rgba(156, 163, 175, 0.5)",
              transform: "translateY(-1px)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => handleFormSubmit(e)}
          variant="contained"
          sx={{
            background: darkMode
              ? "linear-gradient(135deg, rgba(16, 185, 129, 0.9) 0%, rgba(5, 150, 105, 0.9) 100%)"
              : "linear-gradient(135deg, rgba(5, 150, 105, 1) 0%, rgba(16, 185, 129, 1) 100%)",
            color: "#ffffff",
            padding: "10px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textTransform: "none",
            boxShadow: darkMode
              ? "0 4px 12px rgba(16, 185, 129, 0.3)"
              : "0 4px 12px rgba(5, 150, 105, 0.25)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              background: darkMode
                ? "linear-gradient(135deg, rgba(5, 150, 105, 0.9) 0%, rgba(16, 185, 129, 0.9) 100%)"
                : "linear-gradient(135deg, rgba(16, 185, 129, 1) 0%, rgba(5, 150, 105, 1) 100%)",
              transform: "translateY(-2px)",
              boxShadow: darkMode
                ? "0 8px 20px rgba(16, 185, 129, 0.4)"
                : "0 8px 20px rgba(5, 150, 105, 0.35)",
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DynamicFormModal;
